// @flow
import React, { Fragment, Component } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import type { BlocContent } from 'types/NewsletterBloc';
import type { CardType, NewsNunType } from 'types/PageList';
import type { ArticleType } from 'types/Article';
import type { Status } from 'types/Status';

import Description from 'components/fragments/text/Description';
import CardThumbnail from 'components/fragments/card/CardThumbnail';
import Breadcrumb from 'components/fragments/Breadcrumb';
import FooterArticle from 'components/newsletter/FooterArticle';
import FooterNews from 'components/page/FooterNews';

type Props = {
  title: string,
  description: BlocContent[],
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string
  },
  liste_cards: CardType[],
  articles: ArticleType[],
  news: NewsNunType[],
  status: Status,
  match: {
    params: {
      slug: string
    }
  },
  pageSlug: string
};

class PageHubDefault extends Component<Props> {

  _renderCards = () => {
    const { slug } = this.props.match.params;
    const { liste_cards } = this.props;
    const restCards = liste_cards.length % 3;
    if (liste_cards.length === 1 && liste_cards[0].object_id === 0) {
      return null;
    }
    return liste_cards.map<any>((card, index) => {
      const isOnLastLine =
        (restCards === 0 && index >= liste_cards.length - 3) ||
        (restCards !== 0 && index >= liste_cards.length - restCards);

      const classNameContainer = dynamicClassName('col col-md-6 col-lg-4 mb-2 mb-md-3');
      isOnLastLine ? classNameContainer.add('mb-lg-0') : classNameContainer.add('mb-lg-4');
      return (
        <div key={index} className={classNameContainer.build()}>
          <CardThumbnail
            url={`/${slug}/${card.object_slug}`}
            backgroundUrl={card.featured_media}
            title={card.title}
            desc={card.description}
            linkLabel={card.texte_cta}
          />
        </div>
      );
    });
  };

  render() {
    const {
      featured_media,
      title,
      description,
      articles,
      news,
      label,
    } = this.props;
    return (
      <Fragment>
        <section className="banner banner--big">
          <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
            {description && description.length > 0 &&
            <div className="banner__desc">
              <Description description={description}/>
            </div>}
          </div>
        </section>
        <div className="container">
          <div className="row mb-6 mb-md-7 mb-lg-8">{this._renderCards()}</div>
          { news.length > 0 &&
          <FooterNews news={news} slug={''} label={title} /> }
          { news.length === 0 && articles.length > 0 &&
          <FooterArticle articles={articles} slug={label.slug} label={label.name} /> }
        </div>
      </Fragment>
    );
  }
}

export default PageHubDefault;
